module.exports = __webpack_public_path__ + "img/watch-front-2.e24e5293.svg";